import { handleApi } from "../../api/handleApi.js";

export const subscriptionApi = handleApi("subscription/create", "POST", {
  showGlobalLoader: true,
});

export const verifyApi = handleApi("payment/verify", "POST", {
  showGlobalLoader: true,
});
